import React, { useContext, useEffect, useState } from "react";
import pl from "shared/messages/pl";
import { GeneralInformationIntermediary, GeneralInformationSalesPerson, View360Reports } from "view360Card/components";
import { Entity, Intermediary, SalesPerson, SearchEntityTypeEnum, View360CardTab } from "view360Card/models";
import styles from "./entityDetails.module.scss";
import EmptyContent from "../emptyContent/EmptyContent";
import { useStore } from "stores/Stores";
import { KeepMounted, SegmentContent } from "shared/components";
import View360NotesTabContent from "view360Card/features/notes/components/View360NotesTabContent";
import View360EmployeesTabContent from "view360Card/features/intermediaries-list/components/View360EmployeesTabContent";
import { MsTeamsContext } from "msTeams/store";
import { IntermediaryReference_Public } from "shared/service/api/generated";

export interface EntityDetailsProps {
    activeTab: View360CardTab;
    entityDetails: Entity;
}

export const EntityDetails: React.FC<EntityDetailsProps> = (props) => {
    const msTeamsContext = useContext(MsTeamsContext);
    const { configStore } = useStore();
    const isReportsMobileView = msTeamsContext.isMobileClient;

    useEffect(() => {
        const initialize = async () => {
            window.scrollTo(0, 0);
        };

        initialize();
    }, []);

    const getEmptyContent = () => {
        return (
            <SegmentContent>
                <EmptyContent message={pl.common.siteUnderConstruction} graphic="empty" />
            </SegmentContent>
        );
    };

    const getIntermediaryReference = () => {
        if(props.entityDetails.entityType === SearchEntityTypeEnum.SalesPerson) {
            const salesPerson = props.entityDetails as SalesPerson

            return salesPerson.profileList.map(profile => {
                return new IntermediaryReference_Public({
                    id: profile.intermediaryId,
                    name: profile.name,
                    number: profile.number,
                })
            });
        }
        return [];
    }

    const renderEntityDetails = () => {
        return (
            <div className={styles.content}>
                {props.activeTab === View360CardTab.GENERAL_INFORMATION && (
                    <SegmentContent>
                        {props.entityDetails.entityType === SearchEntityTypeEnum.SalesPerson && (
                            <GeneralInformationSalesPerson salesPerson={props.entityDetails as SalesPerson} />
                        )}
                        {props.entityDetails.entityType === SearchEntityTypeEnum.Intermediary && (
                            <GeneralInformationIntermediary intermediary={props.entityDetails as Intermediary} />
                        )}
                    </SegmentContent>
                )}
                <KeepMounted
                    isMounted={props.activeTab === View360CardTab.EMPLOYEES}
                    render={() => (
                        <SegmentContent>
                            <View360EmployeesTabContent intermediaryId={props.entityDetails.id} />
                        </SegmentContent>
                    )}
                ></KeepMounted>
                {configStore.config?.featureFlags.v360Sales ? (
                    <KeepMounted
                        isMounted={props.activeTab === View360CardTab.SALES}
                        render={() => (
                            <View360Reports
                                entityId={props.entityDetails.id!}
                                entityType={props.entityDetails.entityType}
                                isMobileView={isReportsMobileView}
                            />
                        )}
                    ></KeepMounted>
                ) : props.activeTab === View360CardTab.SALES ? (
                    getEmptyContent()
                ) : null}
                {configStore.config?.featureFlags.v360Notes ? (
                    <KeepMounted
                        isMounted={props.activeTab === View360CardTab.NOTES}
                        render={() => {
                            const salesPersonId =
                                props.entityDetails.entityType === SearchEntityTypeEnum.SalesPerson
                                    ? props.entityDetails.id!
                                    : undefined;
                            const intermediaryId =
                                props.entityDetails.entityType === SearchEntityTypeEnum.Intermediary
                                    ? props.entityDetails.id!
                                    : undefined;

                            return (
                                <View360NotesTabContent
                                    salesPersonId={salesPersonId}
                                    intermediaryId={intermediaryId}
                                    intermediaryReference={getIntermediaryReference()}
                                />
                            );
                        }}
                    ></KeepMounted>
                ) : props.activeTab === View360CardTab.NOTES ? (
                    getEmptyContent()
                ) : null}
            </div>
        );
    };

    if (!props.entityDetails) {
        return null;
    }

    return renderEntityDetails();
};
